if (!customElements.get('amare-product-card')) {
  customElements.define('amare-product-card', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-product-thumb-src]').forEach((button) => {
        button.addEventListener('click', () => {
          this.setImage(button.dataset.productThumbSrc);
          this.querySelectorAll('[data-product-thumb-src]').forEach((item) => item.classList.toggle('is-active', item === button));
        });
      });

      this.querySelectorAll('[data-card-variant]').forEach((button) => {
        button.addEventListener('click', () => this.selectVariant(button));
      });

      this.filterThumbnails(this.dataset.selectedColor || '');
    }

    filterThumbnails(colorKey) {
      let visibleCount = 0;
      this.querySelectorAll('[data-product-thumb-src]').forEach((thumb) => {
        const mediaColor = thumb.dataset.mediaColor || '';
        const matches = !mediaColor || !colorKey || mediaColor === colorKey;
        const visible = matches && visibleCount < 3;
        thumb.hidden = !visible;
        if (visible) visibleCount += 1;
      });
    }

    setImage(src) {
      const image = this.querySelector('.amare-product-card__main');
      if (!image || !src) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
    }

    selectVariant(button) {
      const form = this.querySelector('product-form form');
      const variantInput = form?.querySelector('[name="id"]');
      const submit = form?.querySelector('[type="submit"]');
      const title = this.querySelector('[data-card-variant-title]');
      const price = this.querySelector('[data-card-price]');
      const compare = this.querySelector('[data-card-compare]');
      const links = this.querySelectorAll('[data-card-product-link]');
      const available = button.dataset.variantAvailable === 'true';

      this.querySelectorAll('[data-card-variant]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (title) title.textContent = button.dataset.variantTitle;
      if (price) price.textContent = button.dataset.variantPrice;
      if (compare) {
        compare.textContent = button.dataset.variantCompare;
        compare.hidden = button.dataset.variantOnSale !== 'true';
      }
      if (variantInput) {
        variantInput.value = button.dataset.variantId;
        variantInput.disabled = !available;
      }
      if (submit) {
        submit.disabled = !available;
        submit.removeAttribute('aria-disabled');
        const label = submit.querySelector('[data-card-submit-label]');
        if (label) label.textContent = available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
      }
      links.forEach((link) => { link.href = button.dataset.variantUrl; });
      this.filterThumbnails(button.dataset.colorKey || '');
      this.setImage(button.dataset.variantImage);

      const selectedThumb = Array.from(this.querySelectorAll('[data-product-thumb-src]'))
        .find((thumb) => thumb.dataset.productThumbSrc === button.dataset.variantImage);
      this.querySelectorAll('[data-product-thumb-src]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === selectedThumb));
    }
  });
}

if (!customElements.get('amare-model-card')) {
  customElements.define('amare-model-card', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-model-image]').forEach((button) => button.addEventListener('click', () => {
        const image = this.querySelector('img');
        if (image) {
          image.src = button.dataset.modelImage;
          image.removeAttribute('srcset');
          image.alt = `${this.querySelector('b').textContent} ${button.dataset.modelName}`;
        }
        this.querySelector('[data-model-color]').textContent = button.dataset.modelName;
        const price = this.querySelector('.amare-model__price');
        if (price && button.dataset.modelPrice) {
          const prefix = price.dataset.modelPricePrefix || '';
          price.textContent = `${prefix} ${button.dataset.modelPrice}`.trim();
        }
        if (button.dataset.modelUrl) {
          this.querySelectorAll('.amare-model__media, .amare-model__button').forEach((link) => { link.href = button.dataset.modelUrl; });
        }
        this.querySelectorAll('[data-model-image]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }));
    }
  });
}
